module.exports = __webpack_public_path__ + "img/female-black-18dp.23e312e0.svg";